export default __webpack_public_path__ + "static/sdg-2-21dcb18211869e4376d000061ceb3ae9.png";